import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  /**
   * Href of the link
   */
  href: PropTypes.string.isRequired,
  /**
   * Link label
   */
  label: PropTypes.node.isRequired,
  /**
   * Style object passed to the link
   */
  style: PropTypes.object // eslint-disable-line react/forbid-prop-types
};





/**
 * Shows a link that opens the ref in a new tab
 */
function ExternalLink(props) {
  const { href, label, style = {} } = props ?? {};
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      style={style}
      onClick={(event) => event.stopPropagation()}>

      {label}&nbsp;
      <i className="fas fa-arrow-up-right-from-square" />
    </a>);

}

ExternalLink.propTypes = propTypes;


export default ExternalLink;
